import axios from 'axios';
import { apiUrl } from 'src/constants/config';
import { Client } from 'src/pages/client-management/types/client.types';

export interface StudioHandoffUrlResponse {
  url: string;
}

export async function mintStudioHandoffUrl(
  extClientId: string,
  accessToken: string,
): Promise<string> {
  const response = await axios.post<{ url: string }>(
    `${apiUrl}/client/${extClientId}/studio-handoff`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  const url = response.data?.url;
  if (!url) {
    throw new Error('Studio handoff URL missing from response');
  }
  return url;
}

export function getMigratedClients(clients: Client[] | null | undefined): Client[] {
  return clients?.filter((client) => client.studio_ready) ?? [];
}

export function isStudioCutoverActive(clients: Client[] | null | undefined): boolean {
  return clients?.some((client) => client.studio_cutover) ?? false;
}

export async function redirectToStudioIfCutoverActive(
  clients: Client[] | null | undefined,
  accessToken: string,
): Promise<boolean> {
  if (!isStudioCutoverActive(clients)) {
    return false;
  }

  const migratedClients = getMigratedClients(clients);
  if (migratedClients.length === 0) {
    return false;
  }

  const url = await mintStudioHandoffUrl(migratedClients[0].ext_client_id, accessToken);
  window.location.assign(url);
  return true;
}
